import { render, staticRenderFns } from "./ZonaList.vue?vue&type=template&id=135bfc5a&scoped=true&"
import script from "./ZonaList.vue?vue&type=script&lang=js&"
export * from "./ZonaList.vue?vue&type=script&lang=js&"
import style0 from "./ZonaList.vue?vue&type=style&index=0&id=135bfc5a&lang=scss&scoped=true&"
import style1 from "./ZonaList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bfc5a",
  null
  
)

export default component.exports